import { useFormik } from 'formik'
import { FC } from 'react'
import { ButtonType, showAlert, showError } from '../../../../../../../_metronic/helpers'
import { useSearchParams } from 'react-router-dom'
import { createSetor, editSetorCliente } from '../../core/_request'
import { SetorAsoDtoCreate, SetorAsoDtoUpdate, SetorAsoView } from '../../core/_models'
import {
  Button,
  FetchState,
  FormInput,
  ListLoading,
  LoadingIndicator,
  useModal,
} from '../../../../../../components'
import { setorSchema } from './validation/setorSchema'
import { useT } from '_metronic/i18n/Metronici18n'

export const SetorClienteModal: FC = () => {
  const { fetchStates, closeModal } = useModal()
  const { t } = useT()
  const { data: setor } = (fetchStates['setor'] || {}) as FetchState<SetorAsoView>

  const [searchParams] = useSearchParams()
  const idEmpresaCliente = Number(searchParams.get('cliente'))

  const initialValues = {
    nome: setor?.nome || '',
  }
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: setorSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        if (setor) {
          const sector: SetorAsoDtoUpdate = { nome: values.nome, ativo: setor.ativo }
          await editSetorCliente(setor.id, sector)
          showAlert({ title: 'Sucesso!', text: 'Setor alterado com sucesso!', icon: 'success' })
        } else {
          const setor: SetorAsoDtoCreate = { nome: values.nome }
          await createSetor(idEmpresaCliente, setor)
          showAlert({ title: 'Sucesso!', text: 'Setor criado com sucesso!', icon: 'success' })
        }

        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <FormInput formik={formik} label='Nome' placeholder='Digite o nome do setor' name='nome' />

      <div className='d-flex justify-content-center mt-10'>
        <Button type={ButtonType.Reset} onClick={closeModal} className='btn-secondary me-3'>
          {t('common.cancel')}
        </Button>

        <Button type={ButtonType.Submit} className='btn-primary'>
          {formik.isSubmitting ? <LoadingIndicator /> : t('common.send')}
        </Button>
      </div>
      {formik.isSubmitting && <ListLoading />}
    </form>
  )
}
